import styled from 'threads5/styles/styled';

/**
 * Relative container for the "link overlay" (stretched-link) pattern (SITE-5558).
 *
 * Renders `position: relative` so a single nested <LinkOverlay /> can stretch its
 * ::after across the whole box — making the entire area (image + text) clickable
 * with only ONE anchor in the DOM. This is AEO/markdown-safe: no <a> nested inside
 * <a>, and no duplicate link targets.
 *
 * Any other interactive element placed inside the box (a secondary link, a button)
 * is lifted above the overlay so it stays independently clickable. The overlay
 * anchor opts out of that lift via its `data-link-overlay` marker.
 *
 * Defaults to a <div>; pass `as` to render a semantic element (e.g. `as="li"`,
 * `as="article"`).
 */
const LinkBox = styled('div')({
  position: 'relative',
  '& a:not([data-link-overlay]), & button:not([data-link-overlay])': {
    position: 'relative',
    // Must be strictly greater than the overlay ::after's z-index (1) so inner
    // interactive elements paint above it and stay clickable — equal z-index
    // would let the later-in-DOM overlay swallow their clicks.
    zIndex: 2,
  },
});

export default LinkBox;
